@if (loading && active) {
  <div class="parentSpinner">
    <div class="loadingSpinner">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}
